'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifNonApiReason = exports.sendCleanedErrorNotificationsWithPrefix = exports.INVALID_REJECTION_SUFFIX = undefined;
exports.isInvalidRejection = isInvalidRejection;
exports.removeNoStackPrefix = removeNoStackPrefix;

var _sendError = require('./sendError');

var INVALID_REJECTION_SUFFIX = exports.INVALID_REJECTION_SUFFIX = '(invalid promise rejection error with no stack since not instanceof Error)';

var NO_STACK_REGEX = /^\(no stack\) /;

function isInvalidRejection(reason) {
  // Q prefixes the reason with '(no stack)' if the rejection came from a non-Error
  return NO_STACK_REGEX.test(reason);
}

function removeNoStackPrefix(reason) {
  return reason.replace(NO_STACK_REGEX, '');
}

var sendCleanedErrorNotificationsWithPrefix = exports.sendCleanedErrorNotificationsWithPrefix = function sendCleanedErrorNotificationsWithPrefix(prefix, tags) {
  return function (reason) {
    var options = {
      messagePrefix: prefix,
      tags: tags
    };

    if (isInvalidRejection(reason)) {
      reason = removeNoStackPrefix(reason);
      options.messageSuffix = INVALID_REJECTION_SUFFIX;
    }

    (0, _sendError.sendErrorToSentryAndNewRelic)(reason, options);
  };
};

var HAPIJS_REASON_REGEX = /^Error: API request to /;
var HUBHTTP_REASON_REGEX = /^Error: Request for /;

// Only calls func for non-API related rejection reasons.
// The heuistic is a bit hacky, but gets the job done
var ifNonApiReason = exports.ifNonApiReason = function ifNonApiReason(func) {
  return function (reason) {
    if (!HUBHTTP_REASON_REGEX.test(reason) && !HAPIJS_REASON_REGEX.test(reason)) {
      func(reason);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-4.11/js/util/other.js
// module id = 181
// module chunks = 0